/* global $:true module:true Foundation:true */
import debug from "debug";

const MODULE_NAME = 'core/vendor/foundation/extensions/responsive-tabs';
const log = debug(MODULE_NAME);

function changeTabsToAccordions (event, currentBreakpoint, previousBreakpoint) {

	const responsiveTabs = $('.responsive-tabs');
	const toggleType = $('.toggleType');
	const tabWrap = $('.tab-wrap');

	log(`Changed ${previousBreakpoint} > ${previousBreakpoint}`);


	// small only
	if (Foundation.MediaQuery.current === 'small') {

		log("Foundation.MediaQuery.current === 'small'");

		if (responsiveTabs.hasClass('tabs-content')) {

			responsiveTabs.removeClass('tabs-content');
			responsiveTabs.addClass('accordion');
			responsiveTabs.attr('data-accordion', '');
			log("responsiveTabs.container.convertedToAccordion");

			tabWrap.css('display', 'none');
			tabWrap.addClass('accordion-content');
			log("responsiveTabs.tabWraps.convertedToAccordion");

			toggleType.addClass('accordion-item');
			toggleType.removeClass('tabs-panel');
			log("responsiveTabs.toggleTypes.convertedToAccordion");

			$('.toggleType.is-active')
				.children('.tab-wrap')
				.css('display', 'block');
			log("responsiveTabs.toggleTypeActiveTabWrap.displayed");

		}

		$('.accordion-title')
			.on('click', function AccordionTitleClick () {
				const sharedId = $(this).attr('id');

				$(this).children('tab-wrap')
					.css('display', 'none');

				$('.tabs-title.is-active').removeClass('is-active');
				$(`ul.tabs li.${sharedId}`).addClass('is-active');
				$('.tabs-title.is-active a').attr('aria-selected', 'true');
			});
	}

	if (Foundation.MediaQuery.atLeast('medium')) {

		log("Foundation.MediaQuery.atLeast('medium')");

		// medium

		if (responsiveTabs.hasClass('accordion')) {
			responsiveTabs.removeAttr('data-accordion');
			responsiveTabs.removeClass('accordion');
			responsiveTabs.addClass('tabs-content');

			tabWrap.removeClass('accordion-content');
			tabWrap.css('display', '');
			toggleType.removeClass('accordion-item');
			toggleType.addClass('tabs-panel');
		}
	}
}

export default function () {

	$(document).ready(() => {

		changeTabsToAccordions();
		$(window).on('changed.zf.mediaquery', changeTabsToAccordions);
	});

}



// WEBPACK FOOTER //
// ./project/client/src/core/vendor/foundation/extensions/responsive-tabs.js